import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { vagasLumePreparar, vagasLumeAutorizar } from "../services/api";

// 🔗 AUTORIZAÇÃO DA INTEGRAÇÃO COM O VAGASLUME (20/10/2026). O candidato clica "Conectar eaiRH" no VagasLume e cai aqui
// com ?retorno=…&estado=…. Ele vê o que é e o que NÃO é compartilhado e decide. O servidor só aceita o endereço de
// retorno cadastrado (lista de permissão) e devolve o redirecionamento já com o código de uso único.
export default function IntegracaoVagasLumePage() {
  const [q] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const retorno = q.get("retorno") || "";
  const estado = q.get("estado") || "";
  const [prep, setPrep] = useState(null);
  const [erro, setErro] = useState(null);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate(`/entrar?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`, { replace: true });
      return;
    }
    vagasLumePreparar(retorno).then(setPrep).catch((e) => setErro(e.message));
  }, [user, retorno, navigate]);

  const decidir = async (decisao) => {
    setEnviando(true); setErro(null);
    try { const r = await vagasLumeAutorizar(retorno, estado, decisao); window.location.href = r.redirecionar; }
    catch (e) { setErro(e.message); setEnviando(false); }
  };

  if (!user) return null;
  // Mesma regra do servidor (RxEstado): 20–200 caracteres, letras, números, "-" e "_". Conferida já ao abrir, para
  // ninguém clicar em Autorizar num pedido que vai ser recusado.
  const estadoOk = /^[A-Za-z0-9_-]{20,200}$/.test(estado);
  const incompleto = !retorno || !estadoOk;
  const invalido = prep && (!prep.retornoPermitido || incompleto);
  return (
    <div className="max-w-lg mx-auto px-4 py-10">
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-bold text-primary mb-1">Conectar ao VagasLume</h1>
        <p className="text-sm text-gray-500 mb-4">O VagasLume pediu para acompanhar suas candidaturas feitas pelo eaiRH.</p>
        {erro && <p className="mb-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{erro}</p>}
        {!prep && !erro && <p className="text-sm text-gray-500">Carregando…</p>}
        {/* 20/10/2026: abrir o endereço "limpo" (sem ?retorno=&estado=) caía no erro de endereço não autorizado e confundia
            quem testava. Sem os parâmetros, a explicação certa é: esta página abre pelo botão do VagasLume. */}
        {invalido && incompleto && <p className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">Esta página abre pelo botão <b>Conectar eaiRH</b>, dentro do VagasLume. O link chegou incompleto ({!retorno ? <>falta o <code>retorno</code></> : <>o <code>estado</code> precisa ter de 20 a 200 caracteres: letras, números, - ou _</>}).</p>}
        {invalido && !incompleto && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">Este pedido de conexão não veio de um endereço autorizado. Por segurança, nada foi compartilhado.</p>}
        {prep?.retornoPermitido && !incompleto && (
          <>
            <div className="grid gap-3 sm:grid-cols-2 mb-4 text-sm">
              <div className="rounded-xl bg-green-50 p-3">
                <b className="text-green-800">O que o VagasLume vai receber</b>
                <ul className="mt-1 list-disc pl-4 text-green-900">
                  <li>O <b>status</b> de cada candidatura: enviada, entregue, etapa, retorno</li>
                  <li>Vaga, empresa e data</li>
                </ul>
              </div>
              <div className="rounded-xl bg-gray-50 p-3">
                <b className="text-gray-800">O que NÃO é compartilhado</b>
                <ul className="mt-1 list-disc pl-4 text-gray-700">
                  <li>Currículo, e-mail e telefone</li>
                  <li>Pretensão salarial</li>
                </ul>
              </div>
            </div>
            <p className="text-xs text-gray-500 mb-4">
              Ao conectar, o status atual das suas candidaturas em aberto também é enviado, para o painel do VagasLume ficar em dia.
              Você pode desconectar quando quiser, aqui em <b>Minha conta</b> ou no VagasLume.
              {prep.conectadoEm && <> Você já está conectado; conectar de novo substitui a conexão anterior.</>}
            </p>
            <div className="flex flex-wrap gap-2">
              <button disabled={enviando} onClick={() => decidir("autorizar")}
                className="rounded-xl bg-orange-600 px-5 py-2 font-semibold text-white hover:bg-orange-700 disabled:opacity-60">
                {enviando ? "Conectando…" : "Autorizar e conectar"}</button>
              <button disabled={enviando} onClick={() => decidir("negar")}
                className="rounded-xl border border-gray-300 px-5 py-2 font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-60">Não autorizar</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
